const OPTIONAL_STRING_FIELDS = [
  "mainActivityDirection",
  "mainClients",
  "employeesTotal",
  "employeesInstallers",
  "employeesEngineers",
  "employeesCommercial",
  "companyYears",
  "dealerBrands",
  "trainingMountingService",
  "trainingCalculationsDesign",
  "trainingSalesPromotion",
  "plannedAtmosferaVolumeUsd",
  "employeesRenewableEnergy",
  "heardAboutSource",
  "heardAboutSourceOther",
];

function parseCompanyId(company) {
  return {
    ...company,
    id: parseInt(company.id),
  };
}

export function extractStoreCompanies(customerApplication) {
  const { companies } = customerApplication.user?.customer || {};

  if (!companies) {
    return [];
  }

  return companies.map((company) => parseCompanyId(company));
}

export function mapFormCompanies(customerApplication) {
  const { companyId, user, companyName } = customerApplication;
  const { companies } = user?.customer || {};

  if (companies) {
    return [
      companyId ? { id: companyId, name: companyName } : null,
      ...companies.map((company) => parseCompanyId(company)),
    ];
  }

  return companyId ? [{ id: parseInt(companyId), name: companyName }] : [];
}

export function extractRegionManagerIds(customerApplication) {
  const { region, manager } = customerApplication;

  return {
    regionId: region?.id || "",
    managerId: manager?.id || "",
  };
}

export function mapCustomerApplicationToForm(customerApplication, { levelId = "1" } = {}) {
  const {
    companyName,
    companyType,
    companyCode,
    companyFullName,
    companyAccountingName,
    companyEmail,
    companyPhone,
    legalAddress,
    youcontrolSynced,
    sentToOneC,
    verificationErrors,
    creationErrors,
    verifiedAt,
    taxNumber,
    comment,
    user,
    region,
    manager,
    processingManager,
  } = customerApplication;

  const { firstName, lastName, phone, email, roles, id, customer } = user || {};
  const { name } = customer || {};
  const { accessGroup, storage } = manager || {};

  const form = {
    companyName,
    companyFullName,
    companyAccountingName,
    companyEmail,
    companyPhone: companyPhone ? companyPhone : "",
    legalAddress,
    youcontrolSynced,
    sentToOneC,
    verificationErrors,
    creationErrors,
    verifiedAt,
    companyType,
    companyCode,
    name: name ? name : companyName,
    taxNumber,
    comment,
    firstName,
    lastName,
    phone,
    email,
    customerId: customer?.id,
    managerId: manager?.id,
    processingManagerId: processingManager?.id,
    regionId: region?.id,
    userId: id,
    roleId: roles?.[0]?.id,
    accessGroupId: accessGroup?.id,
    storageId: storage?.id,
    levelId,
    companies: mapFormCompanies(customerApplication),
  };

  OPTIONAL_STRING_FIELDS.forEach((field) => {
    form[field] = customerApplication[field] ?? "";
  });

  return form;
}
